import * as React from 'react';
import { Text } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { HomepageAuthenticated } from "./HomepageAuthenticated";
import * as AppConstants from "../context/AppConstants";
import * as AppUtilities from "../context/AppUtilities";
import { Search } from "../components/Search";

const Stack = createNativeStackNavigator();

export function MainStack() {
  return (
    <Stack.Navigator
      screenOptions={({ navigation, route }) => ({
        headerRight: AppUtilities.getHeaderRight(navigation),
        headerTitle: (props) => <Text selectable={true} {...props} style={AppConstants.STYLES.fontSize17} />
      })}
    >
      <>
        <Stack.Screen
          name={AppConstants.SCREENS.HOME}
          component={HomepageAuthenticated}
          options={{ title: "Find Humane", headerShown: false }}
        />
        <Stack.Screen
          name={AppConstants.SCREENS.SEARCH}
          component={Search}
          options={{ title: "Search", headerShown: false }}
        />
      </>
    </Stack.Navigator>
  );
}
